import { React, useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useStyle } from '../../context/styleContext/styleContext';
import axios from 'axios';
import { ShoppingCartContext } from '../../context/shoppingCartContext/shoppingCartContext';
import Button from '@mui/material/Button';
import { toast } from 'react-hot-toast';
import OrderConfirmationModal from '../../pages/Checkout/ConfirmaionModal';
import RemoveItemsFromCartModal from './RemoveItemsFromCartModal';

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { style } = useStyle();
  const { cartItems, clearShoppingCart, cartSubtotal } = useContext(ShoppingCartContext);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [isRemoveItemsFromCartModalOpen, setRemoveItemsFromCartModalOpen] = useState(false);
  const [removeTheseItems, setRemoveTheseItems] = useState([]);

  const openConfirmationModal = () => setConfirmationModalOpen(true);
  const closeConfirmationModal = () => setConfirmationModalOpen(false);
  const closeRemoveItemsModal = () => setRemoveItemsFromCartModalOpen(false);

  const navigate = useNavigate();
  const checkLicenses = async () => {


        const token = localStorage.getItem('token')

        if(!token)
        {
          navigate('/login');
          return(null);
        }

        const dataToSend = {token: token}

        try{
            
            const{data} = await axios.post('/api/get_my_gear', dataToSend)
            //console.log(data)
        if(data.error){
            return null;
            toast.error(data.error)
        }
        else{
            
            var cartItemSKUs = [];
            var alreadyOwnedSKUs = [];
            var listOfMatches = [];

            if(data.length > 0)
            {


              for(var i = 0; i < data.length; i++)
                {
                    alreadyOwnedSKUs.push(data[i].SKU)
                }
    
                for(var i = 0; i < cartItems.length; i++)
                {
                  if(alreadyOwnedSKUs.includes(cartItems[i].SKU))
                  {
                    listOfMatches.push({SKU: cartItems[i].SKU, name:cartItems[i].name})
                  }
                  console.log(cartItems[i].SKU, " ", cartItems[i].name)
                }
    
    
                console.log("list of matches!");
                console.log(listOfMatches);

                setRemoveTheseItems(listOfMatches);

                return(listOfMatches);

            }

            
        }
        }catch(error){
            console.log(error)
            return(null)
        }

        return (null);

  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    var paid = false;
    var message = "";
    var processPayment = false;

    //verify products are not already owned
    const itemsToRemove = await checkLicenses();


if(!itemsToRemove)
{
  processPayment = true;
}
if(itemsToRemove && !itemsToRemove[0])
{
  processPayment = true;
}
if(itemsToRemove && itemsToRemove[0])
  {
    processPayment = false;
    setRemoveItemsFromCartModalOpen(true);
  
  }


if(processPayment)
{

  console.log("NO MATCHES FOUND ON LIST, PROCESSING PAYMENT.... ")
      try {
      if (!stripe || !elements) {
        return;
      }

      setIsProcessing(true);

      const cardNumberElement = elements.getElement(CardNumberElement);

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardNumberElement,
      });

      if (error) {
        setErrorMessage(error.message);
        setIsProcessing(false);
        return;
      }

      console.log("Payment Method ID: ", paymentMethod.id);

      const response = await axios.post('/api/create_payment_intent',
        {
          paymentMethodId: paymentMethod.id,
          currencyType: 'usd',
          totalAmount: Math.round(cartSubtotal * 100)
        },
        {
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${apiKey}`
          }
        }
      );

      const paymentIntentResponse = await response.data;
      message = paymentIntentResponse.message;



      if (paymentIntentResponse.error) {
        setErrorMessage(paymentIntentResponse.error.message);
        setIsProcessing(false);
        toast.error(paymentIntentResponse.message);
      } else {
        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
          paymentIntentResponse.clientSecret
        );

        if (confirmError) {
          setErrorMessage(confirmError.message);
          toast.error(confirmError.message);
        } else if (paymentIntent.status === 'succeeded') {
          paid = true;
          finalizeTransaction();
          clearShoppingCart();
          openConfirmationModal();
        }

        setIsProcessing(false);
      }

    } catch {
      if (!paid) {
        toast.error("ERROR: We were unable to process your payment - Card Declined.");
        setIsProcessing(false);
      } else {
        setIsProcessing(false);
      }
    }


}


  };

  const finalizeTransaction = async () => {
    console.log("Attempting to create license...");
    try {
      const { data } = await axios.post('/api/finalize_transaction', {token:localStorage.getItem('token'), products: cartItems, total: cartSubtotal, salesTax: 0 });
      if (data.error) {
        toast.error(data.error);
      } else {
        toast.success("Transaction successful!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: '20pt',
        color: style.color4,
        backgroundColor: style.color2,
        borderColor:style.color2,
        borderStyle:'solid',
        borderWidth:'1px',
        padding: '5px',
        '::placeholder': {
          color: 'grey',
        },
      },
      invalid: {
        color: 'red',
      },
    },
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={{ margin: 'auto', backgroundColor: style.color1, width:'95%', maxWidth:'300px', color:style.color4 }}>
        <div style={{ marginBottom: '15px' }}>
          <label><strong style={{fontSize:'1.2em'}}>Card Number</strong></label>
          <CardNumberElement options={cardElementOptions} />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label><strong style={{fontSize:'1.2em'}}>Expiration Date</strong></label>
          
          <CardExpiryElement options={cardElementOptions} />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label><strong style={{fontSize:'1.2em'}}>CVC</strong></label>
          <CardCvcElement options={cardElementOptions} />
        </div>

        {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}

        <Button
          type="submit"
          size='small'
          sx={{
            backgroundColor: style.color1,
            color: style.color4,
            borderColor:style.color2,
            boxShadow:10,
            borderWidth:'1px',
            borderStyle:'solid',
            minWidth: '250px',
            fontSize: '1.2em',
            mt:2,
            marginBottom: "15px",
            '&:disabled': {color:style.color4, backgroundColor:style.color2},
            '&:hover': {
                        backgroundColor: style.color2,
      
                        },

          }}
          disabled={!stripe || isProcessing}
        >
          {isProcessing ? 'Processing...' : 'Submit Payment'}
        </Button>

        <div style={{ marginBottom: '25px' }}>
          <Link to={'/shopping-cart'} style={{ color: style.color3 }}>Back To Shopping Cart</Link>
        </div>

        <div id='modal-root'>
          <OrderConfirmationModal isOpen={isConfirmationModalOpen} close={closeConfirmationModal} />
          <RemoveItemsFromCartModal isOpen={isRemoveItemsFromCartModalOpen} close={closeRemoveItemsModal} itemsToRemove={removeTheseItems}/>
        </div>
      </form>
    </>
  );
};

export default CheckoutForm;


